import { PageBlockProps } from '@design-system/page-block';

import { headingBlockMapper } from '~/mappers/headingBlock';

import { PageBlock, PageBlockUI } from './models';

export const pageBlockMapper = ({
  disableGutters,
  element,
  heading,
  mode,
  maxWidth,
}: PageBlock): PageBlockProps =>
  ({
    disableGutters,
    heading: headingBlockMapper(heading),
    ...(mode && { mode }),
    ...(element && { element }),
    ...(maxWidth && { maxWidth }),
  } as PageBlockProps);

export const pageBlockUIMapper = ({
  disableGutters,
  element,
  mode,
  maxWidth,
}: PageBlockUI): PageBlockProps =>
  ({
    disableGutters,
    ...(mode && { mode }),
    ...(element && { element }),
    ...(maxWidth && { maxWidth }),
  } as PageBlockProps);
